export { default } from './QuoteBlock';
export * from './QuoteBlock';
